import { render, staticRenderFns } from "./robotSettingList.vue?vue&type=template&id=d95f2844&scoped=true"
import script from "./robotSettingList.vue?vue&type=script&lang=ts"
export * from "./robotSettingList.vue?vue&type=script&lang=ts"
import style0 from "./robotSettingList.vue?vue&type=style&index=0&id=d95f2844&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95f2844",
  null
  
)

export default component.exports